<template>
  <div class="decoration content-page">
    <div class="tab-header">
      <div class="header-left">
        <!-- <div>
          <span>店铺类型：</span>
          <el-select
            :value="shopType"
            size="small"
            placeholder="请选择店铺类型"
            @change="shopTypeChange"
          >
            <el-option
              v-for="item in shopTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div> -->
        <div class="tip">
          提示:自定义装修前，请选择自定义类型的模板后，再装修，装修发布后提交审核发布。发布后，可实时展示装修效果，不需要再次提交审核。
        </div>
      </div>
      <div class="header-right">
        <el-button type="text" size="medium" @click="saveOrUpdateDecorationPageDataFuc(0)"
          >暂存</el-button
        >
        <el-button type="primary" size="medium" @click="releaseuc">发布</el-button>
      </div>
    </div>
    <div class="tab-content">
      <div class="pane">
        <div class="left scrollbar">
          <ul>
            <li label="首页" class="active">
              <div>
                <i class="el-icon-house"></i>
                <p>首页</p>
              </div>
            </li>
          </ul>
        </div>
        <div class="center scrollbar">
          <div class="content">
            <!---->
            <div>
              <h1 :class="{ active: foldBaseCom }" @click="foldBaseCom = !foldBaseCom">
                <i
                  :class="{
                    'el-icon-caret-bottom': foldBaseCom,
                    'el-icon-caret-right': !foldBaseCom,
                  }"
                ></i
                >基础组件
              </h1>
              <el-popover
                placement="top"
                width="160"
                trigger="hover"
                content="请拖至右边进行装修"
                v-show="foldBaseCom"
              >
                <ul slot="reference">
                  <draggable
                    v-model="baseComponents"
                    :group="{ name: 'component', pull: 'clone', put: false }"
                    :sort="false"
                    filter=".undraggable"
                    :clone="comDragCloneFuc"
                  >
                    <li
                      :class="{
                        undraggable: item.usednum >= item.totlenum,
                      }"
                      v-for="item in baseComponents"
                      :key="item.comType"
                    >
                      <section class="no-phone">
                        <i :class="item.icon"></i>
                        <p>{{ item.comName }}</p>
                        <span>{{ item.usednum }}/{{ item.totlenum }}</span>
                      </section>
                      <component
                        class="no-parts"
                        :is="item.comTag"
                        v-bind="item.props"
                      ></component>
                    </li>
                  </draggable>
                </ul>
              </el-popover>
            </div>
            <div>
              <h1
                :class="{ active: foldAdvanceCom }"
                @click="foldAdvanceCom = !foldAdvanceCom"
              >
                <i
                  :class="{
                    'el-icon-caret-bottom': foldAdvanceCom,
                    'el-icon-caret-right': !foldAdvanceCom,
                  }"
                ></i
                >高级组件
              </h1>
              <el-popover
                placement="top"
                width="160"
                trigger="hover"
                content="请拖至右边进行装修"
                v-show="foldAdvanceCom"
              >
                <ul slot="reference">
                  <draggable
                    v-model="advancedComponents"
                    :group="{ name: 'component', pull: 'clone', put: false }"
                    :sort="false"
                    filter=".undraggable"
                    :clone="comDragCloneFuc"
                  >
                    <li
                      :class="{
                        undraggable: item.usednum >= item.totlenum,
                      }"
                      v-for="item in advancedComponents"
                      :key="item.comType"
                    >
                      <section class="no-phone">
                        <i :class="item.icon"></i>
                        <p>{{ item.comName }}</p>
                        <span>{{ item.usednum }}/{{ item.totlenum }}</span>
                      </section>
                      <component
                        class="no-parts"
                        :is="item.comTag"
                        v-bind="item.props"
                      ></component>
                    </li>
                  </draggable>
                </ul>
              </el-popover>
            </div>
            <!---->
            <div>
              <h1
                :class="{ active: foldMarketingCom }"
                @click="foldMarketingCom = !foldMarketingCom"
              >
                <i
                  :class="{
                    'el-icon-caret-bottom': foldMarketingCom,
                    'el-icon-caret-right': !foldMarketingCom,
                  }"
                ></i
                >营销组件
              </h1>
              <el-popover
                placement="top"
                width="160"
                trigger="hover"
                content="请拖至右边进行装修"
                v-show="foldMarketingCom"
              >
                <ul slot="reference">
                  <draggable
                    v-model="marketingComponents"
                    :group="{ name: 'component', pull: 'clone', put: false }"
                    :sort="false"
                    filter=".undraggable"
                    :clone="comDragCloneFuc"
                  >
                    <li
                      :class="{
                        undraggable: item.usednum >= item.totlenum,
                      }"
                      v-for="item in marketingComponents"
                      :key="item.comType"
                    >
                      <section class="no-phone">
                        <i :class="item.icon"></i>
                        <p>{{ item.comName }}</p>
                        <span>{{ item.usednum }}/{{ item.totlenum }}</span>
                      </section>
                      <component
                        class="no-parts"
                        :is="item.comTag"
                        v-bind="item.props"
                      ></component>
                    </li>
                  </draggable>
                </ul>
              </el-popover>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="phone-content">
            <div class="phone">
              <span style="display: none">0</span>
              <el-tag
                class="setting"
                size="small"
                :type="comActive == 0 ? '' : 'info'"
                @click="comActive = 0"
              >
                全局设置<i class="el-icon-setting"></i>
              </el-tag>
              <div class="state-block border">
                <span>15:59</span>
                <div class="img-block">
                  <img :src="`./static/img/decoration/applet_state.png`" />
                </div>
              </div>
              <div class="block scrollbar">
                <ul
                  :style="{ 'background-color': componentList[0].props.backgroundColor }"
                >
                  <div class="collapse-block">
                    <el-carousel indicator-position="none">
                      <el-carousel-item
                        v-for="(item, index) in componentList[0].props.imgUrlList"
                        :key="index"
                      >
                        <img v-show="item.imgUrl" :src="item.imgUrl" draggable="false" />
                      </el-carousel-item>
                    </el-carousel>
                  </div>
                  <div class="vuedraggable-block">
                    <draggable
                      v-model="componentList"
                      :group="{ name: 'component' }"
                      :options="{ draggable: 'li:not(.unmover)' }"
                      filter=".unmover"
                      @add="comDragAddFuc"
                      @update="comDragUpdateFuc"
                    >
                      <li
                        :class="{
                          active: comActive == index,
                          unmover: index === 0,
                        }"
                        v-for="(item, index) in componentList"
                        :key="index"
                        v-if="item.comTag != 'comNavigationBar'"
                        @click="comActive = index"
                      >
                        <component :is="item.comTag" v-bind="item.props"></component>
                        <el-tag
                          size="small"
                          :type="comActive == index ? '' : 'info'"
                          closable
                          v-if="index != 0"
                          @close="comDeleteFuc(index)"
                        >
                          {{ item.comName }}
                        </el-tag>
                      </li>
                    </draggable>
                  </div>
                  <li
                    class="navigationbar-li"
                    :class="{
                      active:
                        comActive ==
                        componentList.findIndex((val) => {
                          return val.comTag == 'comNavigationBar';
                        }),
                    }"
                    v-if="
                      componentList.findIndex((val) => {
                        return val.comTag == 'comNavigationBar';
                      }) != -1
                    "
                    @click="
                      comActive = componentList.findIndex((val) => {
                        return val.comTag == 'comNavigationBar';
                      })
                    "
                  >
                    <component
                      :is="
                        componentList[
                          componentList.findIndex((val) => {
                            return val.comTag == 'comNavigationBar';
                          })
                        ].comTag
                      "
                      v-bind="
                        componentList[
                          componentList.findIndex((val) => {
                            return val.comTag == 'comNavigationBar';
                          })
                        ].props
                      "
                    ></component>
                    <el-tag
                      size="small"
                      :type="
                        comActive ==
                        componentList.findIndex((val) => {
                          return val.comTag == 'comNavigationBar';
                        })
                          ? ''
                          : 'info'
                      "
                      closable
                      @close="
                        comDeleteFuc(
                          componentList.findIndex((val) => {
                            return val.comTag == 'comNavigationBar';
                          })
                        )
                      "
                    >
                      {{
                        componentList[
                          componentList.findIndex((val) => {
                            return val.comTag == "comNavigationBar";
                          })
                        ].comName
                      }}
                    </el-tag>
                  </li>
                </ul>
              </div>
            </div>
            <div class="drawer scrollbar">
              <div class="card-content">
                <div class="top">
                  <h3 slot="head" class="clear">
                    {{ componentList[comActive].comName }}
                  </h3>
                </div>
                <div class="scrollbar" v-if="componentList.length && comActive !== ''">
                  <component
                    comType="config"
                    :is="componentList[comActive].comTag"
                    v-bind.sync="componentList[comActive].props"
                  ></component>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import comImage from "@/components/appltDecoration/comImage";
import comSwiper from "@/components/appltDecoration/comSwiper";
import comTitle from "@/components/appltDecoration/comTitle";
import comNotice from "@/components/appltDecoration/comNotice";
import comCube from "@/components/appltDecoration/comCube";
import comLine from "@/components/appltDecoration/comLine";
import comQuickPay from "@/components/appltDecoration/comQuickPay";
import comOrderMethod from "@/components/appltDecoration/comOrderMethod";
import comShopInfo from "@/components/appltDecoration/comShopInfo";
import comOrderStatus from "@/components/appltDecoration/comOrderStatus";
import comCouponCenter from "@/components/appltDecoration/comCouponCenter";
import comRecommendedProducts from "@/components/appltDecoration/comRecommendedProducts";
import comTitleBar from "@/components/appltDecoration/comTitleBar";
import comNavigationBar from "@/components/appltDecoration/comNavigationBar";
import { saveOrUpdateDecorationPageData, getDecorationPageData } from "@/api/index";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      baseComponents: [
        {
          comName: "图片",
          comType: 0,
          usednum: 0, //已经使用的个数
          totlenum: 8, //可使用的个数
          icon: "el-icon-picture-outline",
          comTag: `comImage`,
          props: {
            imgUrl: "",
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0,
            marginLeft: 0,
            paddingTop: 0,
            paddingRight: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            radius: 0,
            backgroundColor: "",
            hotList: [],
            jumpLink: {
              type: 1,
              remark: "",
            },
          },
        },
        {
          comName: "轮播图",
          comType: 1,
          usednum: 0, //已经使用的个数
          totlenum: 5, //可使用的个数
          icon: "el-icon-video-camera",
          comTag: `comSwiper`,
          props: {
            comHeight: 200,
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0,
            marginLeft: 0,
            radius: 0,
            imgUrlList: [
              {
                imgUrl: "",
                jumpLink: {
                  type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
                  remark: "",
                },
              },
            ],
          },
        },
        {
          comName: "标题",
          comType: 2,
          usednum: 0, //已经使用的个数
          totlenum: 5, //可使用的个数
          icon: "el-icon-price-tag",
          comTag: `comTitle`,
          props: {
            titleText: "标题",
            textAlign: "left",
            textColor: "rgb(51, 51, 51)",
            borderColor: "rgb(51, 51, 51)",
            backgroundColor: "rgb(255, 255, 255)",
            fontSize: 14,
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0,
            marginLeft: 0,
            paddingTop: 0,
            paddingRight: 0,
            paddingBottom: 0,
            paddingLeft: 5,
            radius: 0,
            hotList: [],
          },
        },
        {
          comName: "公告",
          comType: 3,
          usednum: 0, //已经使用的个数
          totlenum: 5, //可使用的个数
          icon: "el-icon-bell",
          comTag: `comNotice`,
          props: {
            imgUrl: "./static/img/decoration/applet_notice.png",
            fontSize: 14,
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0,
            marginLeft: 0,
            paddingTop: 0,
            paddingRight: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            noticeList: [
              {
                noticeText: "我是公告",
                jumpLink: {
                  type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
                  remark: "",
                },
              },
            ],
            direction: "horizontal",
            textColor: "rgb(51, 51, 51)",
            backgroundColor: "rgb(255, 255, 255)",
          },
        },
        {
          comName: "魔方",
          comType: 4,
          usednum: 0, //已经使用的个数
          totlenum: 5, //可使用的个数
          icon: "el-icon-s-grid",
          comTag: `comCube`,
          props: {
            layoutMode: "mode01",
            comHeight: 200,
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0,
            marginLeft: 0,
            imgUrlList: [
              {
                imgUrl: "",
                jumpLink: {
                  type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
                  remark: "",
                },
              },

              {
                imgUrl: "",
                jumpLink: {
                  type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
                  remark: "",
                },
              },

              {
                imgUrl: "",
                jumpLink: {
                  type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
                  remark: "",
                },
              },
            ],
          },
        },
        {
          comName: "辅助分割",
          comType: 5,
          usednum: 0, //已经使用的个数
          totlenum: 5, //可使用的个数
          icon: "el-icon-minus",
          comTag: `comLine`,
          props: {
            comHeight: 10,
            backgroundColor: "rgb(64, 158, 255, 1)",
          },
        },
        {
          comName: "点餐方式",
          comType: 6,
          usednum: 0, //已经使用的个数
          totlenum: 1, //可使用的个数
          icon: "el-icon-guide",
          comTag: `comOrderMethod`,
          props: {
            dineInIsShow: true,
            dineInTitle: "到店自取",
            dineInSubTitle: "下单免排队",
            dineInIsShowImg: true,
            dineInCustomImg: false,
            dineInCustomImgUrl: "",
            takeOutIsShow: true,
            takeOutTitle: "外卖点单",
            takeOutSubTitle: "一步到位，真快乐",
            takeOutIsShowImg: true,
            takeOutCustomImg: false,
            takeOutCustomImgUrl: "",
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0,
            marginLeft: 0,
            paddingTop: 10,
            paddingRight: 10,
            paddingBottom: 10,
            paddingLeft: 10,
            radius: 8,
            backgroundColor: "rgba(255,255,255,1)",
          },
        },
        {
          comName: "快速买单",
          comType: 7,
          usednum: 0, //已经使用的个数
          totlenum: 1, //可使用的个数
          icon: "el-icon-wallet",
          comTag: `comQuickPay`,
          props: {
            imgUrl: `./static/img/decoration/applet_fast.png`,
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0,
            marginLeft: 0,
            paddingTop: 0,
            paddingRight: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            radius: 0,
            backgroundColor: "",
          },
        },
        {
          comName: "导航",
          comType: 12,
          usednum: 0, //已经使用的个数
          totlenum: 1, //可使用的个数
          icon: "el-icon-position",
          comTag: `comNavigationBar`,
          props: {
            layoutMode: "mode01",
            textColor: "rgb(51, 51, 51))",
            activeTextColor: "rgb(51, 51, 51)",
            backgroundColor: "rgb(255, 255, 255)",
            backgroundImage: "",
            imgUrlList: [
              {
                imgUrl: "",
                activeImgUrl: "",
                jumpLink: {
                  type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
                  remark: "",
                  remarkText: "",
                },
              },
              {
                imgUrl: "",
                activeImgUrl: "",
                jumpLink: {
                  type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
                  remark: "",
                  remarkText: "",
                },
              },
              {
                imgUrl: "",
                activeImgUrl: "",
                jumpLink: {
                  type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
                  remark: "",
                  remarkText: "",
                },
              },
              {
                imgUrl: "",
                activeImgUrl: "",
                jumpLink: {
                  type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
                  remark: "",
                  remarkText: "",
                },
              },
            ],
          },
        },
      ],
      foldBaseCom: true,
      advancedComponents: [
        {
          comName: "店铺信息",
          comType: 8,
          usednum: 0, //已经使用的个数
          totlenum: 1, //可使用的个数
          icon: "el-icon-s-shop",
          comTag: `comShopInfo`,
          props: {
            styleMode: 1,
            marginTop: 0,
            marginRight: 10,
            marginBottom: 0,
            marginLeft: 10,
            paddingTop: 10,
            paddingRight: 10,
            paddingBottom: 10,
            paddingLeft: 10,
            radius: 8,
            backgroundColor: "rgb(255, 255, 255)",
          },
        },
        {
          comName: "订单状态",
          comType: 9,
          usednum: 0, //已经使用的个数
          totlenum: 1, //可使用的个数
          icon: "el-icon-s-order",
          comTag: `comOrderStatus`,
          props: {
            marginTop: 0,
            marginRight: 10,
            marginBottom: 0,
            marginLeft: 10,
            paddingTop: 10,
            paddingRight: 10,
            paddingBottom: 10,
            paddingLeft: 10,
            radius: 8,
            backgroundColor: "rgb(255, 255, 255)",
          },
        },
      ],
      foldAdvanceCom: true,
      marketingComponents: [
        {
          comName: "推荐商品",
          comType: 10,
          usednum: 0, //已经使用的个数
          totlenum: 1, //可使用的个数
          icon: "el-icon-goods",
          comTag: `comRecommendedProducts`,
          props: {
            textColor: "rgb(51, 51, 51)",
            backgroundColor: "rgb(255, 255, 255)",
            titleText: "推荐商品",
            fontSize: 14,
            marginTop: 10,
            marginRight: 10,
            marginBottom: 10,
            marginLeft: 10,
            paddingTop: 10,
            paddingRight: 10,
            paddingBottom: 10,
            paddingLeft: 10,
            radius: 8,
            goodsList: [],
          },
        },
        {
          comName: "领券中心",
          comType: 11,
          usednum: 0, //已经使用的个数
          totlenum: 1, //可使用的个数
          icon: "el-icon-s-claim",
          comTag: `comCouponCenter`,
          props: {
            textColor: "rgb(51, 51, 51)",
            titleText: "领券中心",
            imgUrl: "./static/img/decoration/coupon-center.jpg",
            fontSize: 14,
            marginTop: 10,
            marginRight: 10,
            marginBottom: 10,
            marginLeft: 10,
            paddingTop: 0,
            paddingRight: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            radius: 8,
          },
        },
      ],
      foldMarketingCom: true,
      componentList: [
        {
          comName: "全局设置",
          comTag: "comTitleBar",
          comType: 99,
          props: {
            titleText: "首页",
            titleBackgroundColor: "rgb(255, 255, 255)",
            isShowBar: true,
            imgUrl: "",
            backgroundColor: "rgb(246, 246, 246)",
            imgUrlList: [],
          },
        },
      ],
      comActive: 0,
      comTagMap: {
        0: "comImage",
        1: "comSwiper",
        2: "comTitle",
        3: "comNotice",
        4: "comCube",
        5: "comLine",
        6: "comOrderMethod",
        7: "comQuickPay",
        8: "comShopInfo",
        9: "comOrderStatus",
        10: "comRecommendedProducts",
        11: "comCouponCenter",
        12: "comNavigationBar",
        99: "comTitleBar",
      },
      shopType: 1,
      previousShopType: 1,
      shopTypeList: [
        {
          label: "电商",
          value: 1,
        },
        {
          label: "生鲜",
          value: 2,
        },
        {
          label: "餐饮",
          value: 3,
        },
        {
          label: "美业",
          value: 4,
        },
      ],
      isModify: false,
      shopTypeMap: {
        1: 3,
        4: 2,
        2: 1,
        8: 4,
        5: 1,
      },
    };
  },
  components: {
    draggable,
    comImage,
    comSwiper,
    comTitle,
    comNotice,
    comCube,
    comLine,
    comQuickPay,
    comOrderMethod,
    comShopInfo,
    comOrderStatus,
    comCouponCenter,
    comRecommendedProducts,
    comTitleBar,
    comNavigationBar,
  },
  watch: {
    shopType(value) {
      this.updateDecorationShopType(value);
      let baseComponents = [
        {
          comName: "图片",
          comType: 0,
          usednum: 0, //已经使用的个数
          totlenum: 8, //可使用的个数
          icon: "el-icon-picture-outline",
          comTag: `comImage`,
          props: {
            imgUrl: "",
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0,
            marginLeft: 0,
            paddingTop: 0,
            paddingRight: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            radius: 0,
            backgroundColor: "",
            hotList: [],
            jumpLink: {
              type: 1,
              remark: "",
            },
          },
        },
        {
          comName: "轮播图",
          comType: 1,
          usednum: 0, //已经使用的个数
          totlenum: 5, //可使用的个数
          icon: "el-icon-video-camera",
          comTag: `comSwiper`,
          props: {
            comHeight: 200,
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0,
            marginLeft: 0,
            radius: 0,
            imgUrlList: [
              {
                imgUrl: "",
                jumpLink: {
                  type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
                  remark: "",
                },
              },
            ],
          },
        },
        {
          comName: "标题",
          comType: 2,
          usednum: 0, //已经使用的个数
          totlenum: 5, //可使用的个数
          icon: "el-icon-price-tag",
          comTag: `comTitle`,
          props: {
            titleText: "标题",
            textAlign: "left",
            textColor: "rgb(51, 51, 51)",
            borderColor: "rgb(51, 51, 51)",
            backgroundColor: "rgb(255, 255, 255)",
            fontSize: 14,
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0,
            marginLeft: 0,
            paddingTop: 0,
            paddingRight: 0,
            paddingBottom: 0,
            paddingLeft: 5,
            radius: 0,
            hotList: [],
          },
        },
        {
          comName: "公告",
          comType: 3,
          usednum: 0, //已经使用的个数
          totlenum: 5, //可使用的个数
          icon: "el-icon-bell",
          comTag: `comNotice`,
          props: {
            imgUrl: "./static/img/decoration/applet_notice.png",
            fontSize: 14,
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0,
            marginLeft: 0,
            paddingTop: 0,
            paddingRight: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            noticeList: [
              {
                noticeText: "我是公告",
                jumpLink: {
                  type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
                  remark: "",
                },
              },
            ],
            direction: "horizontal",
            textColor: "rgb(51, 51, 51)",
            backgroundColor: "rgb(255, 255, 255)",
          },
        },
        {
          comName: "魔方",
          comType: 4,
          usednum: 0, //已经使用的个数
          totlenum: 5, //可使用的个数
          icon: "el-icon-s-grid",
          comTag: `comCube`,
          props: {
            layoutMode: "mode01",
            comHeight: 200,
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0,
            marginLeft: 0,
            imgUrlList: [
              {
                imgUrl: "",
                jumpLink: {
                  type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
                  remark: "",
                },
              },

              {
                imgUrl: "",
                jumpLink: {
                  type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
                  remark: "",
                },
              },

              {
                imgUrl: "",
                jumpLink: {
                  type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
                  remark: "",
                },
              },
            ],
          },
        },
        {
          comName: "辅助分割",
          comType: 5,
          usednum: 0, //已经使用的个数
          totlenum: 5, //可使用的个数
          icon: "el-icon-minus",
          comTag: `comLine`,
          props: {
            comHeight: 10,
            backgroundColor: "rgb(64, 158, 255, 1)",
          },
        },
        {
          comName: "点餐方式",
          comType: 6,
          usednum: 0, //已经使用的个数
          totlenum: 1, //可使用的个数
          icon: "el-icon-guide",
          comTag: `comOrderMethod`,
          props: {
            dineInIsShow: true,
            dineInTitle: "到店自取",
            dineInSubTitle: "下单免排队",
            dineInIsShowImg: true,
            dineInCustomImg: false,
            dineInCustomImgUrl: "",
            takeOutIsShow: true,
            takeOutTitle: "外卖点单",
            takeOutSubTitle: "一步到位，真快乐",
            takeOutIsShowImg: true,
            takeOutCustomImg: false,
            takeOutCustomImgUrl: "",
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0,
            marginLeft: 0,
            paddingTop: 10,
            paddingRight: 10,
            paddingBottom: 10,
            paddingLeft: 10,
            radius: 8,
            backgroundColor: "rgba(255,255,255,1)",
          },
        },
        {
          comName: "快速买单",
          comType: 7,
          usednum: 0, //已经使用的个数
          totlenum: 1, //可使用的个数
          icon: "el-icon-wallet",
          comTag: `comQuickPay`,
          props: {
            imgUrl: `./static/img/decoration/applet_fast.png`,
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0,
            marginLeft: 0,
            paddingTop: 0,
            paddingRight: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            radius: 0,
            backgroundColor: "",
          },
        },
        {
          comName: "导航",
          comType: 12,
          usednum: 0, //已经使用的个数
          totlenum: 1, //可使用的个数
          icon: "el-icon-position",
          comTag: `comNavigationBar`,
          props: {
            layoutMode: "mode01",
            textColor: "rgb(51, 51, 51))",
            activeTextColor: "rgb(51, 51, 51)",
            backgroundColor: "rgb(255, 255, 255)",
            backgroundImage: "",
            imgUrlList: [
              {
                imgUrl: "",
                activeImgUrl: "",
                jumpLink: {
                  type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
                  remark: "",
                  remarkText: "",
                },
              },
              {
                imgUrl: "",
                activeImgUrl: "",
                jumpLink: {
                  type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
                  remark: "",
                  remarkText: "",
                },
              },
              {
                imgUrl: "",
                activeImgUrl: "",
                jumpLink: {
                  type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
                  remark: "",
                  remarkText: "",
                },
              },
              {
                imgUrl: "",
                activeImgUrl: "",
                jumpLink: {
                  type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
                  remark: "",
                  remarkText: "",
                },
              },
            ],
          },
        },
      ];
      let advancedComponents = [
        {
          comName: "店铺信息",
          comType: 8,
          usednum: 0, //已经使用的个数
          totlenum: 1, //可使用的个数
          icon: "el-icon-s-shop",
          comTag: `comShopInfo`,
          props: {
            styleMode: 1,
            marginTop: 0,
            marginRight: 10,
            marginBottom: 0,
            marginLeft: 10,
            paddingTop: 10,
            paddingRight: 10,
            paddingBottom: 10,
            paddingLeft: 10,
            radius: 8,
            backgroundColor: "rgb(255, 255, 255)",
          },
        },
        {
          comName: "订单状态",
          comType: 9,
          usednum: 0, //已经使用的个数
          totlenum: 1, //可使用的个数
          icon: "el-icon-s-order",
          comTag: `comOrderStatus`,
          props: {
            marginTop: 0,
            marginRight: 10,
            marginBottom: 0,
            marginLeft: 10,
            paddingTop: 10,
            paddingRight: 10,
            paddingBottom: 10,
            paddingLeft: 10,
            radius: 8,
            backgroundColor: "rgb(255, 255, 255)",
          },
        },
      ];
      let marketingComponents = [
        {
          comName: value == 4 ? "推荐服务" : "推荐商品",
          comType: 10,
          usednum: 0, //已经使用的个数
          totlenum: 1, //可使用的个数
          icon: "el-icon-goods",
          comTag: `comRecommendedProducts`,
          props: {
            textColor: "rgb(51, 51, 51)",
            backgroundColor: "rgb(255, 255, 255)",
            titleText: value == 4 ? "推荐服务" : "推荐商品",
            fontSize: 14,
            marginTop: 10,
            marginRight: 10,
            marginBottom: 10,
            marginLeft: 10,
            paddingTop: 10,
            paddingRight: 10,
            paddingBottom: 10,
            paddingLeft: 10,
            radius: 8,
            goodsList: [],
          },
        },
        {
          comName: "领券中心",
          comType: 11,
          usednum: 0, //已经使用的个数
          totlenum: 1, //可使用的个数
          icon: "el-icon-s-claim",
          comTag: `comCouponCenter`,
          props: {
            textColor: "rgb(51, 51, 51)",
            titleText: "领券中心",
            imgUrl: "./static/img/decoration/coupon-center.jpg",
            fontSize: 14,
            marginTop: 10,
            marginRight: 10,
            marginBottom: 10,
            marginLeft: 10,
            paddingTop: 0,
            paddingRight: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            radius: 8,
          },
        },
      ];
      if (value == 1 || value == 4) {
        baseComponents.splice(6, 1);
        advancedComponents.splice(1, 1);
      }
      this.baseComponents = baseComponents;
      this.advancedComponents = advancedComponents;
      this.marketingComponents = marketingComponents;
    },
    componentList(list) {
      console.log(list);
      let comMap = {};
      list.forEach((val) => {
        if (!comMap[val.comTag]) {
          comMap[val.comTag] = 1;
        } else {
          comMap[val.comTag]++;
        }
      });
      console.log(comMap);
      Object.keys(comMap).forEach((val) => {
        let baseIndex = this.baseComponents.findIndex((subval) => subval.comTag == val);
        let advancedIndex = this.advancedComponents.findIndex(
          (subval) => subval.comTag == val
        );
        let marketingIndex = this.marketingComponents.findIndex(
          (subval) => subval.comTag == val
        );
        console.log(baseIndex, advancedIndex, marketingIndex);
        if (baseIndex != -1) {
          this.baseComponents[baseIndex].usednum = comMap[val];
        } else if (advancedIndex != -1) {
          this.advancedComponents[advancedIndex].usednum = comMap[val];
        } else if (marketingIndex != -1) {
          this.marketingComponents[marketingIndex].usednum = comMap[val];
        }
      });
      this.isModify = true;
    },
  },
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
    }),
  },
  mounted() {
    window.addEventListener("beforeunload", (e) => this.beforeunloadFn(e));
    this.shopType = this.shopTypeMap[this.shopInfo.edcShopType] || 1;
    this.getDecorationPageDataFuc();
  },
  destroyed() {
    window.removeEventListener("beforeunload", (e) => this.beforeunloadFn(e));
  },
  beforeRouteLeave(to, form, next) {
    if (this.isModify) {
      this.$confirm(`切换页面会清空当前设计，是否先暂存当前设计内容？`, "提示", {
        confirmButtonText: "暂存",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(({ value }) => {
          this.saveOrUpdateDecorationPageDataFuc(0);
          next();
        })
        .catch(() => {
          next();
        });
    } else {
      next();
    }
  },
  methods: {
    ...mapActions(["updateDecorationShopType"]),
    async shopTypeChange(value) {
      try {
        // 弹出确认框，等待用户确认操作
        await this.$confirm(
          `切换店铺类型会清空当前设计，是否先暂存当前设计内容？`,
          "提示",
          {
            confirmButtonText: "暂存",
            cancelButtonText: "取消",
            type: "warning",
          }
        );
        // 用户确认，更新 previousValue
        this.saveOrUpdateDecorationPageDataFuc(0);
        this.previousShopType = value;
        this.shopType = value;
        this.comActive = 0;
        this.componentList = [this.componentList[0]];
      } catch {
        // 用户取消，恢复到之前的值
        this.shopType = this.previousShopType;
      }
    },
    beforeunloadFn() {
      if (this.isModify) {
        this.$confirm(`切换页面会清空当前设计，是否先暂存当前设计内容？`, "提示", {
          confirmButtonText: "暂存",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(({ value }) => {
            this.saveOrUpdateDecorationPageDataFuc(0);
          })
          .catch(() => {});
      }
    },
    releaseuc() {
      this.$confirm(`确定发布到该门店吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(({ value }) => {
          this.saveOrUpdateDecorationPageDataFuc(1);
        })
        .catch(() => {});
    },
    getDecorationPageDataFuc() {
      getDecorationPageData({
        shopId: localStorage.shopId,
      }).then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.shopType = this.shopTypeMap[this.shopInfo.edcShopType] || 1;
          this.previousShopType = this.shopTypeMap[this.shopInfo.edcShopType] || 1;
          console.log("shopType", this.shopType);
          // this.shopType =  res.data.type || 1;
          // this.previousShopType = res.data.type || 1;
          let componentList = JSON.parse(res.data.pageComps);
          this.componentList = componentList.map((val) => {
            return {
              comName: val.comName,
              comTag: this.comTagMap[val.comType],
              comType: val.comType,
              props: JSON.parse(val.compPropJson),
            };
          });
          console.log(this.componentList);
          setTimeout(() => {
            this.isModify = false;
          }, 500);
        }
      });
    },
    saveOrUpdateDecorationPageDataFuc(status) {
      let pageCompsJSON = this.componentList.map((val, index) => {
        return {
          comName: val.comName,
          comType: val.comType,
          orderIndex: index,
          compPropJson: JSON.stringify(val.props),
        };
      });
      saveOrUpdateDecorationPageData({
        shopId: localStorage.shopId,
        pageComps: JSON.stringify(pageCompsJSON),
        status,
        type: this.shopType,
      }).then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: status === 0 ? "暂存成功" : "发布成功",
            type: "success",
            duration: 2000,
          });

          this.isModify = false;
        }
      });
    },
    comDragAddFuc(val) {
      console.log("comDragAddFuc", val);
      this.comActive = val.newIndex;
    },
    comDragCloneFuc(val) {
      console.log("comDragCloneFuc", val);
      return JSON.parse(
        JSON.stringify({
          comName: val.comName,
          comTag: val.comTag,
          comType: val.comType,
          props: val.props,
        })
      );
    },
    comDragUpdateFuc(val) {
      this.comActive = val.newIndex;
    },
    comDeleteFuc(index) {
      console.log("comDeleteFuc", index);
      this.$confirm(
        `确定删除当前选中的「${this.componentList[index].comName}」组件吗?`,
        "删除",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(({ value }) => {
          let currentComTag = this.componentList.splice(index, 1)[0].comTag;
          if (this.comActive) {
            this.comActive--;
          }
          let baseIndex = this.baseComponents.findIndex(
            (subval) => subval.comTag == currentComTag
          );
          let advancedIndex = this.advancedComponents.findIndex(
            (subval) => subval.comTag == currentComTag
          );
          let marketingIndex = this.marketingComponents.findIndex(
            (subval) => subval.comTag == currentComTag
          );
          console.log(currentComTag, baseIndex, advancedIndex, marketingIndex);
          if (baseIndex != -1) {
            this.baseComponents[baseIndex].usednum--;
          } else if (advancedIndex != -1) {
            this.advancedComponents[advancedIndex].usednum--;
          } else if (marketingIndex != -1) {
            this.marketingComponents[marketingIndex].usednum--;
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  height: calc(100% - 50px) !important;
  .tab-header {
    display: flex;
    justify-content: flex-end;
    .header-left {
      flex: 1;
      .tip {
        display: flex;
        align-items: center;
        font-size: 16px;
        color: red;
      }
    }
  }
  .tab-content {
    width: 100%;
    height: calc(100% - 67px);
    display: block;
  }
}
.red {
  color: #f66568;
}
.green {
  color: #33ad57;
}
.gray {
  color: #999;
}
.baseColor {
  color: #409eff;
}
.baseWhite {
  color: #fff;
}
.margin-left-20 {
  margin-left: 20px;
}
.margin-left-15 {
  margin-left: 15px;
}
.margin-left-10 {
  margin-left: 10px;
}
.margin-right-10 {
  margin-right: 10px;
}
.margin-top-10 {
  margin-top: 10px;
}
.ellipsis-1 {
  overflow: hidden;
  text-overflow: ellipsis;
  line-clamp: 1;
}
.flex-1 {
  flex: 1;
}
.ellipsis-2 {
  overflow: hidden;
  text-overflow: ellipsis;
  line-clamp: 2;
}
.flex-2 {
  flex: 2;
}
.ellipsis-3 {
  overflow: hidden;
  text-overflow: ellipsis;
  line-clamp: 3;
}
.flex-3 {
  flex: 3;
}
.ellipsis-4 {
  overflow: hidden;
  text-overflow: ellipsis;
  line-clamp: 4;
}
.flex-4 {
  flex: 4;
}
.ellipsis-5 {
  overflow: hidden;
  text-overflow: ellipsis;
  line-clamp: 5;
}
.flex-5 {
  flex: 5;
}
.ellipsis-6 {
  overflow: hidden;
  text-overflow: ellipsis;
  line-clamp: 6;
}
.flex-6 {
  flex: 6;
}
.ellipsis-7 {
  overflow: hidden;
  text-overflow: ellipsis;
  line-clamp: 7;
}
.flex-7 {
  flex: 7;
}
.ellipsis-8 {
  overflow: hidden;
  text-overflow: ellipsis;
  line-clamp: 8;
}
.flex-8 {
  flex: 8;
}
.ellipsis-9 {
  overflow: hidden;
  text-overflow: ellipsis;
  line-clamp: 9;
}
.flex-9 {
  flex: 9;
}
.ellipsis-10 {
  overflow: hidden;
  text-overflow: ellipsis;
  line-clamp: 10;
}
.flex-10 {
  flex: 10;
}
.flex {
  display: flex;
}
.align-items {
  align-items: center;
}
.j-center {
  justify-content: center;
}
.j-between {
  justify-content: space-between;
}
.self-center {
  align-self: center;
}
.column {
  flex-direction: column;
}
.wrap {
  flex-wrap: wrap;
}
.text-l {
  text-align: left;
}
.text-r {
  text-align: right;
}
.text-c {
  text-align: center;
}
.pd-lr-10 {
  padding-left: 10px;
  padding-right: 10px;
}
.pd-t-10 {
  padding-top: 10px;
}
.line-30 {
  line-height: 30px;
}
.c-409eff {
  color: #409eff;
}
.bold {
  font-weight: 700;
}
.pointer {
  cursor: pointer;
}
.cw-100 {
  width: 100%;
}
.pane {
  display: flex;
  flex-wrap: nowrap;
  height: 100%;
  overflow: hidden;
  .left {
    width: 100px;
    min-width: 100px;
    background-color: #f5f7fa;
    border-right: 1px solid #ebeef5;
    height: inherit;
    overflow-y: scroll;
    ul li {
      text-align: center;
      border-bottom: 1px solid #fff;
      background-color: #f5f7fa;
      min-height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      cursor: pointer;
      i {
        font-size: 25px;
      }
      p {
        line-height: 30px;
      }
      &.active {
        color: #409eff;
        background-color: #fff;
      }
      &:hover {
        background-color: #fff;
      }
      .mask {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background-color: rgba(0, 0, 0, 0.5);
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        border-radius: 2px;
      }
    }
  }
  .center {
    height: inherit;
    overflow-y: scroll;
    width: 200px;
    min-width: 200px;
    .content {
      padding: 10px;
      padding-top: 0;
      user-select: none;
      & > div {
        margin-bottom: 10px;
        cursor: pointer;
        h1 {
          line-height: 34px;
          i {
            margin-right: 5px;
          }
          &.active {
            color: #409eff;
          }
        }
        ul {
          width: 100%;
          & > div {
            display: flex;
            flex-wrap: wrap;
          }
          li {
            cursor: move;
            padding: 15px;
            max-width: 50%;
            min-width: 50%;
            flex: 1;
            text-align: center;
            border: 1px solid #ebeef5;
            border-top: 0;
            box-sizing: border-box;
            &:hover {
              background-color: #f5f5f5;
            }
            &.undraggable {
              background-color: #f5f5f5;
              cursor: no-drop;
            }
          }
        }
      }
    }
    .content > div ul li:first-child,
    .content > div ul li:nth-child(2) {
      border-top: 1px solid #ebeef5;
    }
    .content > div ul li {
      &:nth-child(2n) {
        border-left: 0;
      }
      i {
        font-size: 25px;
        color: #409eff;
      }
      span {
        color: #bbb;
      }
      .no-parts {
        display: none;
      }
    }
  }
  .w120 {
    width: 120px;
    min-width: 120px;
  }
  .w20 {
    width: 20px;
    min-width: 20px;
  }
  .right {
    flex: 1;
    height: inherit;
  }
}
ul {
  // height: inherit;
  &.fence {
    border-right: 1px solid #ebeef5;
    li {
      border-bottom: 1px solid #ebeef5;
      line-height: 55px;
      text-align: center;
      cursor: pointer;
    }
  }
}
ul.fence li.active,
ul.fence li.activeBranch {
  color: #409eff;
}
.phone-content {
  position: relative;
  height: inherit;
  display: flex;
  flex-wrap: nowrap;
  .phone {
    padding-top: 12px;
    height: inherit;
    .block {
      width: 490px;
      overflow: hidden;
      overflow-y: scroll;
      height: 76vh;
      &.scrollbar {
        position: relative;
      }
    }
    .setting {
      position: absolute;
      left: 385px;
      top: 12px;
      width: 85px;
    }
    ul {
      position: relative;
      width: 375px;
      margin-right: 58px;
      background-size: 100% 100%;
      border: 1px solid #ebeef5;
      .collapse-block {
        position: absolute;
        height: 100%;
        left: 0;
        top: 0;
        width: 375px;
        z-index: 0;
      }
    }
  }
}
.phone-content .phone ul .vuedraggable-block {
  position: relative;
  z-index: 9;
  & > div {
    width: 377px;
    min-height: 75.5vh;
    border-top: none;
  }
  li {
    width: 375px;
    min-height: 1px;
    position: relative;
    cursor: pointer;
    border-bottom: 0;
    &.active {
      background-image: linear-gradient(0deg, transparent 6px, rgb(64, 158, 255) 0px),
        linear-gradient(0deg, transparent 50%, rgb(64, 158, 255) 0px),
        linear-gradient(90deg, transparent 50%, rgb(64, 158, 255) 0px),
        linear-gradient(90deg, transparent 50%, rgb(64, 158, 255) 0px);
      background-position-x: 0px, 100%, 0px, 0px;
      background-position-y: 0px, 0px, 0px, 100%;
      background-size: 1px 12px, 1px 12px, 12px 1px, 12px 1px;
      background-repeat: repeat-y, repeat-y, repeat-x, repeat-x;
      background-attachment: initial, initial, initial, initial;
      background-origin: initial, initial, initial, initial;
      background-clip: initial, initial, initial, initial;
      background-color: initial;
      animation: move2-064ff445 1s linear infinite;
      padding: 1px;
    }
  }
}
@keyframes move2-064ff445 {
  to {
    background-position: 0 -12px, 100% 12px, 12px 0, -12px 100%;
  }
}
.phone-content {
  .open-set {
    margin-top: 20px;
  }
  .phone ul {
    .no-phone {
      display: none !important;
    }
    .vuedraggable-block {
      .unmover {
        border-bottom: 1px solid #ebeef5;
      }
    }
    li {
      .el-tag {
        font-size: 10px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 385px;
        min-width: 70px;
        cursor: pointer;
        i {
          margin-left: 7px;
        }
      }
      &.navigationbar-li {
        position: sticky;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 99;
      }
    }
  }
}
.phone-content .open-set .state-block {
  position: absolute;
  z-index: 10;
  border: none;
}
.list-content {
  display: flex;
  flex-wrap: nowrap;
  position: relative;
  height: inherit;
  .list-card {
    flex: 3;
    overflow-y: scroll;
    .change-content {
      display: flex;
      flex-wrap: nowrap;
      flex-wrap: wrap;
      padding: 10px;
      .phone {
        width: 375px;
        height: 780px;
        border: 1px solid #ebeef5;
        margin-right: 10px;
        transform: scale(0.7);
        margin-left: -60px;
        margin-right: -38px;
        margin-top: -100px;
        margin-bottom: -100px;
        cursor: pointer;
        &.active {
          position: relative;
          border: 1px solid #409eff;
          &:after {
            content: "";
            position: absolute;
            border-bottom: 20px solid #409eff;
            border-left: 20px solid transparent;
            width: 0;
            height: 0;
            right: 0;
            bottom: 0;
          }
        }
      }
      p {
        text-align: center;
        margin-top: 10px;
      }
    }
  }
  .drawer {
    overflow-y: scroll;
  }
}
.drawer {
  flex: 1.5;
  height: inherit;
  border-left: 1px solid #ebeef5;
  background-color: #fff;
  padding: 10px;
  h3 {
    font-size: 14px;
    line-height: 24px;
    border-bottom: 1px solid #f5f5f5;
    border-left: 3px solid #409eff;
    padding-left: 10px;
    margin-bottom: 10px;
  }
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 400;
}
.card-content {
  height: inherit;
  display: flex;
  flex-direction: column;
}

.card-content .top {
  overflow: hidden;
}

.card-content > div:nth-child(2) {
  flex: 1;
  overflow: scroll;
  padding-bottom: 20px;
}
.el-select {
  margin-right: 10px;
}
.img-preview img {
  width: auto;
  max-width: 100%;
  margin: 20px auto;
  display: block;
}
.box {
  width: 148px;
  height: 148px;
  overflow: hidden;
}
.title {
  font-size: 12px;
  color: #f0c68e;
  text-align: center;
}
.tip {
  font-size: 12px;
  margin-top: 5px;
  color: #ebb56d;
}
.focus {
  font-weight: 800;
  font-size: 13px;
}
.state-block {
  padding: 10px;
  overflow: hidden;
  padding-right: 12px;
  border-bottom: none;
  box-sizing: border-box;
  width: 375px;
  &.border {
    width: 377px;
    border: 1px solid #ebeef5;
    border-bottom: 0;
  }
  span {
    font-size: 12px;
    color: #000;
  }
  .img-block {
    float: right;
    width: 65px;
  }
  section {
    width: 100%;
    overflow: hidden;
    margin-top: 5px;
    img {
      width: 87px;
      float: right;
    }
  }
}
.shop-block {
  margin-right: 10px;
}
.out-app .el-input {
  margin-right: 10px;
}
</style>

<style lang="less">
.decoration {
  .tip {
    font-size: 12px;
    margin-top: 5px;
    color: #ebb56d;
  }
  .card-content > div:nth-child(2) .el-form,
  .card-content > div:nth-child(2) .el-form .el-form-item {
    margin-bottom: 5px;
  }
  .slider-block {
    max-width: 400px;
    position: relative;
  }

  .slider-block .set-radius {
    position: absolute;
    right: -80px;
    top: 0;
  }
  .phone-content .phone ul .collapse-block .el-carousel,
  .phone-content .phone ul .collapse-block .el-carousel__container,
  .phone-content .phone ul .collapse-block img {
    height: 100%;
  }
  img:not(.notFull img) {
    width: 100%;
  }
  img {
    display: block;
  }
}
.collapse-content {
  margin-bottom: 10px;
  padding-top: 10px;
  .el-collapse {
    margin-bottom: 10px;
    .el-collapse-item__content {
      padding-bottom: 8px;
    }
  }
  .collapse-title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .foot {
    .el-button {
      width: 100%;
    }
  }
}
</style>
